import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { EssentialTravelInformationTypes } from '../actions/actions.types'

type EssentialTravelInformationState = ApplicationState['essentialTravelInformation']

export function essentialTravelInformationReducer(
	state: EssentialTravelInformationState = [],
	action: IAction,
): EssentialTravelInformationState {
	switch (action.type) {
		case EssentialTravelInformationTypes.GetEssentialTravelInformation.SUCCESS:
			return action.payload
	}
	return state
}
